module.exports = __webpack_public_path__ + "img/1560ee9.jpg";